import { render, staticRenderFns } from "./property-owned.vue?vue&type=template&id=3ab25298"
import script from "./property-owned.vue?vue&type=script&lang=js"
export * from "./property-owned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports